<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="navbar-brand" href="#"></a>
  <ul class="nav navbar-nav mr-auto d-md-down-none">
    <li class="nav-item">
      <a class="nav-link navbar-toggler" href="#" appSidebarToggler>&#9776;</a>
    </li>
  </ul>

  <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link dropdown-toggle cursor" data-toggle="dropdown" aria-expanded="false" dropdownToggle>
        <img src="https://www.gravatar.com/avatar/0?d=mm&f=y" class="img-avatar">
        <span class="d-md-down-none" *ngIf="currentUser">{{ currentUser.email }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/logout']">
          <i class="fa fa-lock"></i> {{'GUARD.AUTH.LOGOUT' | translate}}
        </a>
      </div>
    </li>
    <li class="nav-item d-md-down-none">
      <div class="nav-link navbar-toggler">&nbsp;</div>
    </li>
  </ul>
</header>

<div class="app-body">
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <!--<li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard']">
            <i class="icon-speedometer"></i> Mantenedores
            <span class="badge badge-info">NEW</span>
          </a>
        </li>-->
        <li class="nav-item nav-dropdown" routerLinkActive="closed" appNavDropdown>
          <a class="nav-link nav-dropdown-toggle" href="#" appNavDropdownToggle>
            <i class="fa fa-credit-card"></i> {{'ADMINISTRATIONS.GENERAL.PLURAL' | translate}}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/administrations/list']">
                {{'ADMINISTRATIONS.GENERAL.LIST' | translate}}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/administrations/create']">
                {{'ADMINISTRATIONS.GENERAL.CREATE' | translate}}
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item nav-dropdown" routerLinkActive="closed" appNavDropdown>
          <a class="nav-link nav-dropdown-toggle" href="#" appNavDropdownToggle>
            <i class="fa fa-credit-card"></i> {{'REPORTS.GENERAL.PLURAL' | translate}}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/administration-community']">
                {{'REPORTS.ADMINISTRATION_COMMUNITIES.TITLE' | translate}}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/report-emails']">
                {{'REPORTS.EMAIL.MENU_TITLE' | translate}}
              </a>
            </li>
          </ul>
        </li>
<!--        <li class="nav-item">-->
<!--          <a class="nav-link" routerLinkActive="active" [routerLink]="['/tools']">-->
<!--            {{'TOOLS.TITLE' | translate}}-->
<!--          </a>-->
<!--        </li>-->
        <li class="nav-item nav-dropdown" routerLinkActive="closed" appNavDropdown>
          <a class="nav-link nav-dropdown-toggle" href="#" appNavDropdownToggle>
            <i class="fa fa-credit-card"></i> {{'PUBLICATIONS.GENERAL.PLURAL' | translate}}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/publications/home']">
                {{'PUBLICATIONS.HOME.HOME_PUBLICATION' | translate}}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/publications/create']">
                {{'PUBLICATIONS.GENERAL.CREATE_PUBLICATION' | translate}}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/publications/list']">
                {{'PUBLICATIONS.GENERAL.LIST' | translate}}
              </a>
            </li>
          </ul>
        </li>
        <!--<li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/permissions']">
            <i class="fa fa-bars"></i>{{'GENERAL.MENU.PERMISSIONS' | translate}}
          </a>
        </li>-->
      </ul>
    </nav>
  </div>

  <!-- Main content -->
  <main class="main">

    <!-- Breadcrumb -->
    <ol class="breadcrumb mb-0">
      <app-breadcrumbs></app-breadcrumbs>
    </ol>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
    <!-- /.conainer-fluid -->
  </main>
</div>

<footer class="app-footer">
  <span class="float-right">
<!--    <strong>Administración:</strong> {{currentAdministration}} - -->
<!--    <strong>Comunidad:</strong> {{currentCommunity}}-->
  </span>
</footer>



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.html